(function () {
  function initCatNav(root) {
    var pillScroll = root.querySelector('.etq-catnav__pills');
    var prev = root.querySelector('.etq-catnav__arrow--prev');
    var next = root.querySelector('.etq-catnav__arrow--next');

    function updateArrows() {
      if (!pillScroll || !prev || !next) return;
      var overflow = pillScroll.scrollWidth > pillScroll.clientWidth + 2;
      prev.hidden = !overflow;
      next.hidden = !overflow;
    }

    if (prev && next && pillScroll) {
      prev.addEventListener('click', function () { pillScroll.scrollBy({ left: -200, behavior: 'smooth' }); });
      next.addEventListener('click', function () { pillScroll.scrollBy({ left: 200, behavior: 'smooth' }); });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    // Keep the active pill scrolled into view
    var active = root.querySelector('.etq-catnav__pill.is-active');
    if (active && pillScroll) {
      active.scrollIntoView({ inline: 'center', block: 'nearest' });
    }
  }

  document.querySelectorAll('.etq-catnav').forEach(initCatNav);
})();